import React from 'react';

const IconSpinnerMixus = ({ size = 'xs', speed = 'normal', className = '' }) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
  };

  const speedClasses = {
    slow: 'animate-spin-slow',
    normal: 'animate-spin',
    fast: 'animate-spin-fast',
  };

  const selectedSize = sizeClasses[size as keyof typeof sizeClasses] || sizeClasses.md;
  const selectedSpeed = speedClasses[speed as keyof typeof speedClasses] || speedClasses.normal;

  return (
    <div className={`${selectedSize} relative ${className}`}>
      <svg className={`w-full h-full ${selectedSpeed}`} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="45" stroke="url(#gradient)" strokeWidth="10" />
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FEC670">
              <animate attributeName="stop-color" values="#FEC670; #FE9D8B; #F966B8; #C0ABF0; #A5F3FE; #FEC670" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.25" stopColor="#FE9D8B">
              <animate attributeName="stop-color" values="#FE9D8B; #F966B8; #C0ABF0; #A5F3FE; #FEC670; #FE9D8B" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.5" stopColor="#F966B8">
              <animate attributeName="stop-color" values="#F966B8; #C0ABF0; #A5F3FE; #FEC670; #FE9D8B; #F966B8" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="0.75" stopColor="#C0ABF0">
              <animate attributeName="stop-color" values="#C0ABF0; #A5F3FE; #FEC670; #FE9D8B; #F966B8; #C0ABF0" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="1" stopColor="#A5F3FE">
              <animate attributeName="stop-color" values="#A5F3FE; #FEC670; #FE9D8B; #F966B8; #C0ABF0; #A5F3FE" dur="4s" repeatCount="indefinite" />
            </stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default IconSpinnerMixus;
